module.exports = "/api/cdn/public/static-assets/images/d3b3dcbdbf143c40a3c124213145ac80.png";